import { render, staticRenderFns } from "./AddDrip.vue?vue&type=template&id=22ba2c3b&"
import script from "./AddDrip.vue?vue&type=script&lang=js&"
export * from "./AddDrip.vue?vue&type=script&lang=js&"
import style0 from "./AddDrip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports